export const treatmentRates = [
  {
    label: 'N/A',
    value: 'na',
  },
  {
    label: 'Per Head',
    value: 'per_head',
  },
  {
    label: 'Per Weight',
    value: 'per_weight',
  },
  {
    label: 'g per 100L',
    value: 'g_per_100l',
  },
  {
    label: 'mL per 100L',
    value: 'ml_per_100l',
  },
  {
    label: 'Other',
    value: 'other',
  },
]
